import React from 'react';

import CreateFromSchemaButton from 'processes/dashboard/CreateFromSchemaButton';
import {OpenCreateModalArgs} from 'requests/dashboard/openCreateRequestModal';

import {RequestTemplateGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTemplateGraphQL';
import {RequestTaskSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';
import {RequestSchema} from '../RequestConstants';
import getInitialRequestProps from '../templates/getInitialRequestProps';

export interface NewRequestDropdownProps {
  schemas: Array<RequestSchema> | null;
  onOpenCreateModal: (openModalArgs: OpenCreateModalArgs) => void;
  requestTemplatesById: Record<string, RequestTemplateGraphQL>;
  requestTaskSchemasById: Record<string, RequestTaskSchemaGraphQL>;
}

export default function NewRequestDropdown(props: NewRequestDropdownProps): JSX.Element {
  function hasSchemasAndAllTemplates(): boolean {
    if (props.schemas == null || props.requestTemplatesById == null) {
      return false;
    }
    for (const schema of props.schemas) {
      for (const templateId of schema.requestTemplateIds) {
        if (props.requestTemplatesById[templateId] == null) {
          return false;
        }
      }
    }
    return true;
  }

  return (
    <CreateFromSchemaButton
      schemas={hasSchemasAndAllTemplates() ? props.schemas : null}
      onSelect={(schema: RequestSchema) => {
        props.onOpenCreateModal(
          getInitialRequestProps(schema, props.requestTemplatesById, props.requestTaskSchemasById)
        );
      }}
    />
  );
}
